import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../uicomponent';
import { UIComponentView } from '../uicomponentview';
import { FileUploadStatus } from '../fileupload/fileuploadcomponent';
import { BaseContext } from '../../../utils/basecontext';
import { DragDropFileUploadView } from './dragdropfileuploadview';
import { UIComponentCSSStyle } from '../uicomponentcss';
import { DragDropFileUploadCSSStyleImpl } from './dragdropfileuploadcss';


export interface DragDropFileUploadProps extends UIComponentProps
{
    fileUploadStatus: FileUploadStatus;
    uploadProgressStatus: number;
    onReupload(): void;
    onFileSelected(): void;
    invalidFile(msg: string): void;
}

export interface DragDropFileUploadState extends UIComponentState
{
    fileName: string;
    uploadProgressStatus: number;
    fileUploadStatus: FileUploadStatus;
}

export interface DragDropFileUploadHandler extends UIComponentHandler
{
    onReupload(): void;
    onSelectFile(fileName: string): void;
}

export class DragDropFileUploadComponent extends UIComponentImpl<DragDropFileUploadProps, DragDropFileUploadState, UIDataModel> implements DragDropFileUploadHandler
{
 
    constructor(props: DragDropFileUploadProps)
    {
        super(props);

        this.state = {fileName: "", fileUploadStatus: props.fileUploadStatus, uploadProgressStatus: props.uploadProgressStatus};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new DragDropFileUploadView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new DragDropFileUploadCSSStyleImpl(applicationContext);
    }

    componentWillReceiveProps(nextProps: DragDropFileUploadProps)
    {
        this.setState({fileUploadStatus: nextProps.fileUploadStatus, uploadProgressStatus: nextProps.uploadProgressStatus});
    }

    // getData()
    // {
    //    return new FormItemModel(DataValueFactory.
    //         createDataValue(DataValueTypes.USER_DEFINED, 0, (this.getView() as DragDropFileUploadView).getData()));
    // }

    validate(): boolean
    {
       return (this.getView() as DragDropFileUploadView).validate();
    }

    onSelectFile(fileName: string)
    {   
        this.setState({fileName: fileName});
        this.props.onFileSelected();
    }

    clearData()
    {
        this.setState({fileName: ""});
        this.getView().clearData();
    }

    onReupload(): void 
    {
        this.props.onReupload();
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/dragdropfile/dragdropfileuploadcomponent.tsx